import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function useIsAuth(path = "/") {
  const isAuth = useSelector((state) => state?.auth?.isAuth);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuth) {
      navigate(path);
    }
  }, [isAuth, navigate, path]);

  return null;
}
